/* eslint-disable camelcase */
import { setGlobalOptions } from '@thsf2e/useRequest'
import { createInstance } from '@thsf2e/useRequest/lib/create'
import { dataFormat, responseConfig } from '@/services/utils'
import { currentUrl, isDev } from '@/services/utils/index'


export const baseURL = isDev ? '/ai-writer/api' : `//${currentUrl}/ai-writer/api`
// export const baseURL = `//${currentUrl}/ai-writer/api`   // 对外dev调试

// async-task 服务 baseURL（文生图等任务相关接口）
// 使用协议相对地址，保持和线上实际域名一致
export const asyncTaskBaseURL = '//writorai.ainvest.com/async-task'

export const sseUrl = baseURL + '/v1/writer'
// 图片接口测试环境地址
export const imgHostnameTest = 'https://testm.10jqka.com.cn/med/api'
// 图片接口生产环境地址
export const imgHostnameProd = 'https://med.10jqka.com.cn/api'
// 图片接口生产开发地址
export const imgHostnameDev = 'http://yapi.myhexin.com/yapi/mock_v2/311322/api'

// occ的用户服务
export const occUserService = `//${currentUrl}/user_server/api`

export const getImgHost = () => {
  // if (isDev) return imgHostnameDev
  // 测试环境接口暂时用不了，直接用生产的接口
  // const isText = location.hostname.includes('aiwriter-test')
  // if (isText) return imgHostnameTest
  return imgHostnameProd
}

// 获取OCC标注平台数据标注的地址的前缀
export const getAnnotationUrlPrefix = () => {
  return `//${currentUrl}`
}

setGlobalOptions({
  baseURL,
  dataFormat,
  plugins: {
    response: responseConfig,
  },
})

export default createInstance